// @flow
import * as React from 'react';
import { ExternalLink, Link } from '../../../typography';
import { DangerButton, PrimaryButton, SecondaryButton } from '../buttons';

type ButtonLinkProps = {|
  href: string,
  children: string,
|};

const PrimaryButtonLink = ({ href, children }: ButtonLinkProps) => {
  return (
    <Link href={href}>
      <PrimaryButton onClick={() => {}} as={'span'}>
        {children}
      </PrimaryButton>
    </Link>
  );
};
PrimaryButtonLink.displayName = 'PrimaryButtonLink';

const PrimaryButtonExternalLink = ({ href, children }: ButtonLinkProps) => {
  return (
    <ExternalLink href={href}>
      <PrimaryButton onClick={() => {}} as={'span'}>
        {children}
      </PrimaryButton>
    </ExternalLink>
  );
};
PrimaryButtonExternalLink.displayName = 'PrimaryButtonExternalLink';

const SecondaryButtonLink = ({ href, children }: ButtonLinkProps) => {
  return (
    <Link href={href}>
      <SecondaryButton onClick={() => {}} as={'span'}>
        {children}
      </SecondaryButton>
    </Link>
  );
};
SecondaryButtonLink.displayName = 'SecondaryButtonLink';

const SecondaryButtonExternalLink = ({ href, children }: ButtonLinkProps) => {
  return (
    <ExternalLink href={href}>
      <SecondaryButton onClick={() => {}} as={'span'}>
        {children}
      </SecondaryButton>
    </ExternalLink>
  );
};
SecondaryButtonExternalLink.displayName = 'SecondaryButtonExternalLink';

const DangerButtonLink = ({ href, children }: ButtonLinkProps) => {
  return (
    <Link href={href}>
      <DangerButton onClick={() => {}} as={'span'}>
        {children}
      </DangerButton>
    </Link>
  );
};
DangerButtonLink.displayName = 'DangerButtonLink';

const DangerButtonExternalLink = ({ href, children }: ButtonLinkProps) => {
  return (
    <ExternalLink href={href}>
      <DangerButton onClick={() => {}} as={'span'}>
        {children}
      </DangerButton>
    </ExternalLink>
  );
};
DangerButtonExternalLink.displayName = 'DangerButtonExternalLink';

export {
  PrimaryButtonLink,
  PrimaryButtonExternalLink,
  SecondaryButtonLink,
  SecondaryButtonExternalLink,
  DangerButtonLink,
  DangerButtonExternalLink,
};
